module.exports = {"id":"188770","name":"Admir Mehmedi","rating":"76","photo":"./data/images/photos/0/188770.png","club":{"name":"VfL Wolfsbourg","logo":"./data/images/clubs/VfLWolfsbourg.png"},"positions":["MD","BU","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AdmirMehmedi0.json
// module id = 101
// module chunks = 0